import { observable, action } from "mobx";
import { IBaseModel } from "./IBaseModel";
import * as Raven from "raven-js";
import { IConfig } from "../IConfig";
const config: IConfig = require("Config");

export class AsyncOperationsModel implements IBaseModel {
    
    @observable asyncOperationsCount: number = 0;
    @observable errorMessages: string[] = [];

    @action.bound
    setErrorMessages(messages: string[]) {
        this.errorMessages.splice(0, this.errorMessages.length);
        this.errorMessages = this.errorMessages.concat(messages);
    }
    @action.bound
    incrementAsyncOperations() {
        this.asyncOperationsCount = this.asyncOperationsCount + 1;
    }

    @action.bound
    decrementAsyncOperations() {
        this.asyncOperationsCount = this.asyncOperationsCount + 1;
    }
    @action.bound
    reportError(error: Error) {
        if (!config.isDebug) {
            Raven.captureException(error);
        }
    }
    // tslint:disable-next-line:no-empty
    prepare() {
        
    }
}


// WEBPACK FOOTER //
// ./src/utility/AsyncOperationsModel.ts